import _typeof from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
/* 
登录成功
    ↓
获取用户信息 (uniqueId, userId)
    ↓
配置 4 个 WebSocket 地址
    ↓
遍历创建 4 个连接


退出登录
    ↓
遍历所有 WebSocket
    ↓
逐个关闭
    ↓
清空状态
 */
import WS from '@/utils/ws';
var state = {
  group: {
    alarm: {},
    // 告警模块
    msg: {},
    // 集中设备模块
    notice: {},
    rdcsm50: {},
    // 新添加 五零所单灯
    responseData: {} //新添加 接口收到OK回复的信息
  },

  url: '',
  data: {},
  body: null
};
var getters = {
  url: function url(state) {
    return state.url;
  },
  data: function data(state) {
    return state.data;
  },
  body: function body(state) {
    return state.body;
  },
  group: function group(state) {
    return state.group;
  }
};
var mutations = {
  SET_WS_URL: function SET_WS_URL(state, url) {
    state.url = url;
  },
  SET_WS_BODY: function SET_WS_BODY(state, ws) {
    state.body = ws;
  },
  SET_WS_DATA: function SET_WS_DATA(state, data) {
    state.data = data;
  },
  SET_MSG_FUNC: function SET_MSG_FUNC(state, func) {
    state.body.dealMessageFunc = func;
  },
  SET_GROUP: function SET_GROUP(state, one) {
    state.group[one.name] = one;
  }
};
var actions = {
  loadWsData: function loadWsData(_ref) {
    var commit = _ref.commit,
      state = _ref.state;
    state.body.dealMessageFunc = function (data) {
      commit('SET_WS_DATA', data);
    };
  },
  // 初始化所有 WebSocket 连接（登录后调用）
  initWebSocket: function initWebSocket(_ref2) {
    var dispatch = _ref2.dispatch,
      rootState = _ref2.rootState;
    // 从 rootState 直接获取用户信息
    var uniqueId = rootState.user.uniqueId;
    var userId = rootState.user.userId;
    if (uniqueId === undefined || uniqueId === null || userId === undefined || userId === null) {
      console.error('用户信息不完整，无法初始化 WebSocket', {
        uniqueId: uniqueId,
        userId: userId
      });
      return;
    }

    // WebSocket URL 配置（需要拼接 uniqueId 和 userId）
    var wsConfigs = [{
      name: 'msg',
      url: "".concat(process.env.VUE_APP_WS_API, "/api/v1/ws/msg/").concat(uniqueId, "/").concat(userId)
    }, {
      name: 'alarm',
      url: "".concat(process.env.VUE_APP_WS_API, "/api/v1/ws/alarm/").concat(uniqueId, "/").concat(userId)
    }, {
      name: 'notice',
      url: "".concat(process.env.VUE_APP_WS_API, "/api/v1/ws/notice/").concat(uniqueId)
    }, {
      name: 'rdcsm50',
      url: "".concat(process.env.VUE_APP_WS_API, "/api/v1/ws/50rdcsm/").concat(uniqueId, "/").concat(userId)
    }, {
      name: 'responseData',
      url: "".concat(process.env.VUE_APP_WS_API, "/api/v1/ws/data/").concat(uniqueId, "/").concat(userId)
    }];

    // 遍历初始化所有 WebSocket 连接
    wsConfigs.forEach(function (config) {
      dispatch('loadWS', config);
    });
  },
  // 关闭所有 WebSocket 连接（退出登录时调用）
  destroyAllWS: function destroyAllWS(_ref3) {
    var dispatch = _ref3.dispatch,
      state = _ref3.state;
    // 关闭所有已连接的 WebSocket（只有 body 存在时才调用）
    Object.keys(state.group).forEach(function (name) {
      if (state.group[name] && state.group[name].body) {
        dispatch('destroyWS', name);
      }
    });

    // 关闭主 WebSocket
    if (state.body) {
      state.body.wsClose(state.body);
    }
  },
  loadWS: function loadWS(_ref4, item) {
    var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      state = _ref4.state;
    if (_typeof(item) === String) {
      commit('SET_WS_BODY', WS.createWebSocket(item.url));
      dispatch('loadWsData', item.name);
    } else {
      var one = {
        name: item.name,
        body: WS.createWebSocket(item.url),
        data: null
      };
      one.body.dealMessageFunc = function (data) {
        state.group[one.name].data = data;
        return data;
      };
      commit('SET_GROUP', one);
    }
  },
  destroyWS: function destroyWS(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (name) {
      var _state$group$name;
      var ws = (_state$group$name = state.group[name]) === null || _state$group$name === void 0 ? void 0 : _state$group$name.body;
      // 检查 body 存在且 wsClose 是函数
      if (ws && typeof ws.wsClose === 'function') {
        ws.wsClose();
      }
      commit('SET_GROUP', {
        name: name,
        url: null,
        data: null,
        body: null
      });
    } else {
      var _ws = state.body;
      if (_ws && typeof _ws.wsClose === 'function') {
        _ws.wsClose();
      }
      commit('SET_WS_URL', '');
      commit('SET_WS_BODY', null);
      commit('SET_WS_DATA', {});
    }
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};